export const CONFIG_API_URL = 'ui/partner/configuration';

export const FEATURE_FLAGS_API_URL = `${CONFIG_API_URL}/feature_flags`;

export const configurationQueryKeys = {
  config: [CONFIG_API_URL, 'config'],
};
